import { CheckIcon, CopyIcon } from "lucide-react";
import type { MouseEvent } from "react";
import { useState } from "react";
import { useTranslation } from "../../i18n";
import { copyToClipboard } from "../../utils/clipboard";
import { Button } from "../Button/Button";
import type { CopyButtonProps } from "./types";

export const CopyButton = (props: CopyButtonProps) => {
  const { copyContent, onClick, ...buttonProps } = props;
  const { t } = useTranslation();
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async (e: MouseEvent<HTMLButtonElement>) => {
    onClick?.(e);

    const success = await copyToClipboard(copyContent);
    if (success) {
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 1000);
    }
  };

  return (
    <Button
      {...buttonProps}
      aria-label={isCopied ? t("copyButton.copied") : t("copyButton.copy")}
      startIcon={isCopied ? <CheckIcon /> : <CopyIcon />}
      onClick={handleCopy}
    >
      {t("copyButton.copy")}
    </Button>
  );
};
